// extracted by mini-css-extract-plugin
export default {"wrapper":"Greetings_wrapper__iMye7","text":"Greetings_text__wnR74","fixed-top":"Greetings_fixed-top__8NUDr"};